import { SelectionModel } from '@angular/cdk/collections';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { take, debounceTime } from 'rxjs/operators';
import { CustomerManageOrdersService } from '../../../service/cutomer-manage-order.service';
import { EncryptionService } from '../../../service/encryption.service';
import { HelperService } from '../../../service/helper.service';
import swal from "sweetalert2";

@Component({
  selector: 'app-selling-catalog-detail',
  templateUrl: './selling-catalog-detail.component.html',
  styleUrls: ['./selling-catalog-detail.component.scss']
})
export class SellingCatalogDetailComponent implements OnInit {

  title = 'ORDERMANAGEMENT.SellingCatalogDetails';
  ServiceCatalogList: any = new MatTableDataSource([]);
  page: any = 1;
  itemsPerPage: any = '10';
  totalItems: any = 0;
  limit: any = 10;
  search: any = '';
  sortBy: any = '';
  sortKey = '';
  sortClass: any = 'down';
  noRecordFound = false;
  filter: any;
  serviceIds = [];
  public requestPara = { search: '', page: 1, limit: 10, sortBy: '', sortKey: '' };
  displayedColumns: string[] = ['Item Name', 'Type', 'Fixed Price', 'Customer Price'];
  private subject: Subject<string> = new Subject();
  sidebarMenuName: string;
  // private searchSubject: Subject<string> = new Subject();
  @ViewChild('table') table: MatTable<any>;
  servicePermission: any;
  loginUserId: any;
  getSellingId:any;
  sellingCatalogName:any;
  constructor(public dialog: MatDialog,
    private ApiServices: CustomerManageOrdersService,
    private helper: HelperService,
    private translate: TranslateService,
    private route: ActivatedRoute,private encryptionService: EncryptionService,
    private router: Router) {
  
  }

  ngOnInit(): void {
    const loginUser = this.encryptionService.getDataFromLocalStorage('NPLoginId');
    this.loginUserId = JSON.parse(loginUser);
    console.log('loginUserId', this.loginUserId)
    this.sideMenuName();
    const id = this.route.snapshot.paramMap.get('id');
    this.getSellingId = id;
    this.getSellingList(this.getSellingId);
  }

  sideMenuName() {
    this.sidebarMenuName = this.translate.instant('ORDERMANAGEMENT.SellingCatalogMenu');
    this.helper.sideMenuListName.next(this.sidebarMenuName);
  }

  getSellingList(getSellingId){
    this.helper.toggleLoaderVisibility(true);
    this.ApiServices.getSellingCatalogDetails(getSellingId).subscribe((res: any) => {
      console.log('res', res.data.catalogList)
      this.helper.toggleLoaderVisibility(false);
      if (res.result) {
        this.ServiceCatalogList = res.data.catalogList;
        this.sellingCatalogName = res.data.sellingCatalogName;
        this.totalItems = res.data.totalcount;
        this.noRecordFound = this.ServiceCatalogList.length > 0;

      }
    }, (err: any) => {
      this.helper.toggleLoaderVisibility(false);
      swal.fire(
        '',
        this.translate.instant(err?.error?.message),
        'info'
      );
    });
  }


  redirectToOrder(){
    localStorage.setItem('sellingCatalogId', JSON.stringify(this.getSellingId))
    this.router.navigate(['customer-order/add-edit-order/']);
  }


  getCatalogType(sellingCatalogType) {
    if (sellingCatalogType == 'ITEM') {
        return 'ORDERMANAGEMENT.UNITMENU'
    } else if (sellingCatalogType == 'ITEMCOLLECTION') {
        return 'ORDERMANAGEMENT.TASK'
    } else if (sellingCatalogType == 'SUPERCOLLECTION') {
        return 'ORDERMANAGEMENT.MICROTASK';
    }
}

}
